<div *ngIf="isLoadComponent" class="w-100 mt-3 inline-flex justify-content-center">

  <p-panel class="w-100" header="Постер">

    <ng-template pTemplate="content">

      <div [ngSwitch]="($loadFileInfoTable | async)">
        <ng-template [ngSwitchCase]="false">
          <label [textContent]="noFileMessage"></label>

          <p-messages severity="info">
            <ng-template pTemplate>
              <div class="flex flex-column">
                <p>Обращаем ваше внимание, что постеры принимаются только в формате PDF.</p>
                <a href="https://support.microsoft.com/ru-ru/office/%D1%81%D0%BE%D1%85%D1%80%D0%B0%D0%BD%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BF%D1%80%D0%B5%D0%B7%D0%B5%D0%BD%D1%82%D0%B0%D1%86%D0%B8%D0%B9-powerpoint-%D0%B2-%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%82%D0%B5-pdf-9b5c786b-9c6e-4fe6-81f6-9372f77c47c8" target="_blank">Как сохранить презентацию Power Point в формат PDF</a>
              </div>

            </ng-template>
        </p-messages>
        </ng-template>

        <ng-template [ngSwitchCase]="true">
          <table class="table table-sm table-hover">
            <tbody>
              <tr>
                <th scope="row" class="p-column-8">Название</th>
                <td> {{ fileInfo?.name }} </td>
              </tr>

              <tr>
                <th scope="row" class="p-column-8">Размер</th>
                <td> {{ fileInfo?.size }} </td>
              </tr>

              <tr>
                <th scope="row" class="p-column-8">Последнее изменение</th>
                <td> {{ fileInfo?.lastModified }} </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>

      <!-- <div *ngIf="pdfSrcView !== ''">
        <b>DOC VIEW</b>
        <ngx-extended-pdf-viewer [src]="pdfSrcView"></ngx-extended-pdf-viewer>
      </div> -->

    </ng-template>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-sm p-button-warning mr-3" label="Загрузить" icon="pi pi-file-pdf"
         (click)="fileInput.click()"></button>
      <input type="file" (change)="onSelectFile($event)" hidden #fileInput accept=".pdf" />

      <button *ngIf="isDownloadBtn" pButton type="button" class="p-button-sm p-button-warning mr-3" label="Скачать"
        icon="pi pi-download"  (click)="onDownloadPoster()"></button>

      <button *ngIf="isDeleteBtn" pButton type="button" class="p-button-sm p-button-danger" label="Удалить"
        icon="pi pi-trash"  (click)="onDeletePoster()"></button>

    </ng-template>

  </p-panel>

</div>
